/**
 * Strings of polls and forwarding (2026-10-29): the composer's "+" menu, the
 * poll creator, a poll in a message, its end notice, the Forward dialog and
 * a forwarded message.
 */
import type { Dict } from './core';

export const pollsEn: Dict = {
  // the composer's "+" menu
  'pl.plus': 'Add',
  'pl.upload': 'Upload images',
  'pl.create': 'Create poll',
  // the creator
  'pl.new.title': 'Create a poll',
  'pl.new.question': 'Question',
  'pl.new.questionPh': 'What question do you want to ask?',
  'pl.new.answers': 'Answers',
  'pl.new.answerPh': 'Type your answer',
  'pl.new.answerN': 'Answer {n}',
  'pl.new.add': 'Add another answer',
  'pl.new.remove': 'Remove answer {n}',
  'pl.new.emoji': 'Pick an emoji for answer {n}',
  'pl.new.noEmoji': 'No emoji',
  'pl.new.duration': 'Duration',
  'pl.new.multi': 'Allow multiple answers',
  'pl.new.post': 'Post',
  'pl.dur.1': '1 hour',
  'pl.dur.4': '4 hours',
  'pl.dur.8': '8 hours',
  'pl.dur.24': '24 hours',
  'pl.dur.72': '3 days',
  'pl.dur.168': '1 week',
  'pl.dur.336': '2 weeks',
  // a poll in a message
  'pl.a11y': 'Poll: {q}',
  'pl.pickOne': 'Select one answer',
  'pl.pickMany': 'Select one or more answers',
  'pl.votes': { one: '{n} vote', other: '{n} votes' },
  'pl.leftD': '{n}d left',
  'pl.leftH': '{n}h left',
  'pl.leftM': '{n}m left',
  'pl.closed': 'Poll closed',
  'pl.vote': 'Vote',
  'pl.show': 'Show results',
  'pl.back': 'Back to voting',
  'pl.change': 'Change vote',
  'pl.remove': 'Remove vote',
  'pl.mine': 'Your vote',
  'pl.winner': 'Most votes',
  'pl.pct': '{n}%',
  'pl.end': 'End poll now',
  'pl.endTitle': 'End this poll now?',
  'pl.endBody': 'Everyone will see the final results, and nobody can vote any more.',
  'pl.ended': 'Poll ended',
  // the "poll ended" notice
  'pl.result': "{name}'s poll {q} has closed.",
  'pl.resultGone': "{name}'s poll has closed.",
  'pl.resultWin': '{a} won with {n}.',
  'pl.resultTie': 'It ended in a tie.',
  'pl.resultNone': 'Nobody voted.',
  'pl.view': 'View poll',
  // forwarding
  'fw.forward': 'Forward',
  'fw.title': 'Forward to',
  'fw.search': 'Search channels and DMs',
  'fw.max': 'You can forward to up to {n} places at once.',
  'fw.picked': { one: '{n} selected', other: '{n} selected' },
  'fw.none': 'No channel or DM matches “{q}”.',
  'fw.empty': 'There is nowhere you can forward this.',
  'fw.dm': 'Direct message',
  'fw.group': 'Group',
  'fw.comment': 'Add an optional message',
  'fw.send': 'Send',
  'fw.sent': { one: 'Forwarded', other: 'Forwarded to {n} places' },
  'fw.partial': 'Forwarded to {ok} of {n}. {err}',
  'fw.tag': 'Forwarded',
  'fw.from': 'Go to the original message',
  'fw.images': { one: '{n} image', other: '{n} images' },
  // the server's refusals (Discord's codes)
  'ns.err.520001': 'This poll has ended.',
  'ns.err.520003': "A poll can't be edited.",
  'ns.err.520004': "That emoji can't be used in a poll.",
  'ns.err.520006': 'Only a poll can be ended.',
  // the console's flags
  'cfg.off.polls': 'Polls are turned off by the admins right now.',
  'cfg.off.message_forwarding': 'Forwarding is turned off by the admins right now.',
  // the role and channel editors
  'ns.perm.SEND_POLLS': 'Create polls',
  'ns.permd.SEND_POLLS': 'Post polls in text channels.',
  // the audit log
  'um.audit.pollEnd': '{actor} ended a poll by {target} in {channel}',
};
